import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { StaticInterceptor } from './static.http-interceptor';
import { Observable } from 'rxjs';


export const ASSETS_URL_REGEX = /assets\//;
export const RESOURCES_URL_REGEX = /resources\//;

@Injectable()
export class NonCacheInterceptor extends StaticInterceptor implements HttpInterceptor {

  protected internalIntercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req.clone({
      url: req.url + '?t=' + new Date().getTime()
    });
    return next.handle(request);
  }
}
